import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { ProfileAPI } from '../profile_api/constants/profile.constant';
import { map } from 'rxjs/internal/operators/map';
import { BehaviorSubject } from 'rxjs/index';
import { GlobalConstants } from '../../../../common/constants/global.constant';
import { DevicesConstants } from '../devices/constants/devices.constants';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  userId = sessionStorage.getItem('userId');
  userIds = 'userid4@ipos.com';
  userRole = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  resetSideNav = new BehaviorSubject(false);
  emitInstallationPackage = this.resetSideNav.asObservable();
  PROFILE_URL = ProfileAPI.SLASH_PROFILE + ProfileAPI.SLASH_USER_ID + ProfileAPI.SLASH + this.userId + ProfileAPI.PROFILES_URL;
  GENERATE_URL = this.PROFILE_URL + ProfileAPI.SLASH;
  isCurrentGamingPackageSelectedForDownload : boolean = false;
  constructor(private httpClient: HttpClient,
    private httpMethod: HttpMethodsService) { }

    getAllProfilesByUser(retailerId: string, pageNum?: number, sortBy?: string, sortType?: string, tabIndex?: number, filterValue?: string, filterString?: string) {
      let url;
      if (tabIndex) {
        url = (filterValue === 'custom') ? ((this.userRole === GlobalConstants.REGIONALHQ) ? this.PROFILE_URL + ProfileAPI.RETAILER_ID + retailerId +
          ProfileAPI.PUSH_PROFILE + ProfileAPI.PAGE_NO + pageNum : this.PROFILE_URL + ProfileAPI.PUSH_PROFILE_QUERY +
          ProfileAPI.PAGE_NO + pageNum) : ProfileAPI.PACKAGE_HANDLER + ProfileAPI.RETAILERS_ID + retailerId + ProfileAPI.PUSH_PROFILE;
      } else {
        url = (this.userRole === GlobalConstants.REGIONALHQ || this.userRole === GlobalConstants.SRT_ADMIN) ? this.PROFILE_URL + ProfileAPI.RETAILER_ID + retailerId + ProfileAPI.PAGE_NO + pageNum : this.PROFILE_URL +
          DevicesConstants.PARAM_PAGENUMBER + pageNum;
      } 
      if (filterString) {
        url = `${url}${filterString}`;
      }
      url+= DevicesConstants.SORT_BY + sortBy + DevicesConstants.SORT_TYPE + sortType;
      return this.httpMethod.get(url)
        .pipe(map((res: any) =>
          res));
    }

  getAllGeneratedProfiles(profileId?: string) {
    const url = this.GENERATE_URL + profileId;
    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }
  getAllPushProfilesByUser(retailerId?: string, pagenum?: number, selectedValue?: string) {
    if ((selectedValue === 'custom') || (!selectedValue)) {
      var url = this.userRole === GlobalConstants.REGIONALHQ ? this.PROFILE_URL + ProfileAPI.RETAILER_ID + retailerId : this.PROFILE_URL;
      url += ProfileAPI.PUSH_PROFILE_QUERY + ProfileAPI.PROFILE_SORT_ASC;
      url += pagenum ? ProfileAPI.PAGE_NO + pagenum : '';
    }
    else {
      var url = ProfileAPI.PACKAGE_HANDLER + ProfileAPI.RETAILERS_ID + retailerId + ProfileAPI.PUSH_PROFILE;
    }
    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  emitPackageInstallation(data) {
    this.resetSideNav.next(data);
  }

  createDuplicateProfile(profileId: string, profilename: string) {
    //IIT2-8971 Added encodeURIComponent to handle &amp in queryParameters
    const encodedProfileName = encodeURIComponent(profilename)
    const url = this.PROFILE_URL + ProfileAPI.SLASH + profileId + ProfileAPI.PROFILE_NAME + encodedProfileName;

    return this.httpMethod.post(url, '')
      .pipe(map((res: any) =>
        res));
  }

  removeProfile(profileId) {
    const url = this.PROFILE_URL + ProfileAPI.SLASH + profileId;
    return this.httpMethod.delete(url)
      .pipe(map((res: any) =>
        res));
  }

  updateProfileProgressStatus(profileID) {
    const url = ProfileAPI.SLASH_USER_ID + ProfileAPI.SLASH + this.userId + ProfileAPI.PROFILES_URL + ProfileAPI.SLASH + profileID + '?packageStatus=draft&progressStatus=failed';
    return this.httpMethod.post(url, '')
      .pipe(map((res: any) =>
        res));
  }
}
